import { render } from "./guideTop10.vue?vue&type=template&id=6e4d0266"
import script from "./guideTop10.vue?vue&type=script&lang=js"
export * from "./guideTop10.vue?vue&type=script&lang=js"

import "./guideTop10.vue?vue&type=style&index=0&id=6e4d0266&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__